import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext'

const TermsConditions = () => {
    const { t } = useLanguage();

    return (
        <div id='website-responsive'>
            <div className='m-5-1' style={{ backgroundColor: '#FFFFFF' }}>
                <div className='left-padding5rem1 right-padding5rem1 py-lg-5 py-4'>

                    {/* Page Title */}
                    <div className='pt-lg-4 pt-3 pb-3'>
                        <h1 className='fs-ss-40-1 text-lato text-ss-black fw-700 text-center'>
                            {t('terms.title')}
                        </h1>
                    </div>

                    {/* Graphic Design Services */}
                    <section className='mb-4'>
                        <h2 className='fs-ss-32 text-lato fw-700 text-ss-black mb-3'>
                            {t('terms.graphicDesignServices')}
                        </h2>
                        <p className='fs-ss-16 text-lato text-ss-black'>
                            {t('terms.graphicDesignServicesText')}
                        </p>
                    </section>

                    {/* Web Development Services */}
                    <section className='mb-4'>
                        <h2 className='fs-ss-32 text-lato fw-700 text-ss-black mb-3'>
                            {t('terms.webDevelopmentServices')}
                        </h2>
                        <p className='fs-ss-16 text-lato text-ss-black'>
                            {t('terms.webDevelopmentServicesText')}
                        </p>
                    </section>

                    {/* Content Writing Services */}
                    <section className='mb-4'>
                        <h2 className='fs-ss-32 text-lato fw-700 text-ss-black mb-3'>
                            {t('terms.contentWritingServices')}
                        </h2>
                        <p className='fs-ss-16 text-lato text-ss-black'>
                            {t('terms.contentWritingServicesText')}
                        </p>
                    </section>

                    {/* How It Works */}
                    <section className='mb-4'>
                        <h3 className='fs-ss-28 text-lato text-ss-black fw-700 mb-3'>
                            {t('terms.howItWorks')}
                        </h3>
                        <p className='fs-ss-16 text-lato text-ss-black'>
                            {t('terms.howItWorksText')}
                        </p>
                    </section>

                    {/* Blog Writing */}
                    <section className='mb-4'>
                        <h2 className='fs-ss-24 text-lato fw-700 text-ss-black mb-3'>
                            {t('terms.blogWriting')}
                        </h2>
                        <p className='fs-ss-16 text-lato text-ss-black'>
                            {t('terms.blogWritingText')}
                        </p>
                    </section>

                    {/* Article Writing */}
                    <section className='mb-4'>
                        <h2 className='fs-ss-24 text-lato fw-700 text-ss-black mb-3'>
                            {t('terms.articleWriting')}
                        </h2>
                        <p className='fs-ss-16 text-lato text-ss-black'>
                            {t('terms.articleWritingText')}
                        </p>
                    </section>

                    {/* Creative Script Writing */}
                    <section className='mb-4'>
                        <h2 className='fs-ss-24 text-lato fw-700 text-ss-black mb-3'>
                            {t('terms.creativeScriptWriting')}
                        </h2>
                        <p className='fs-ss-16 text-lato text-ss-black'>
                            {t('terms.creativeScriptWritingText')}
                        </p>
                    </section>

                    {/* Social Media Marketing */}
                    <section className='mb-4'>
                        <h2 className='fs-ss-24 text-lato fw-700 text-ss-black mb-3'>
                            {t('terms.socialMediaMarketing')}
                        </h2>
                        <p className='fs-ss-16 text-lato text-ss-black'>
                            {t('terms.socialMediaMarketingText')}
                        </p>
                    </section>

                    {/* SEO */}
                    <section className='mb-4'>
                        <h2 className='fs-ss-24 text-lato fw-700 text-ss-black mb-3'>
                            {t('terms.searchEngineOptimization')}
                        </h2>
                        <p className='fs-ss-16 text-lato text-ss-black'>
                            {t('terms.searchEngineOptimizationText')}
                        </p>
                    </section>

                    {/* Note */}
                    <p className='fw-500 text-lato'>
                        <em>
                            {t('terms.note')}
                        </em>
                    </p>

                </div>
            </div>
        </div>
    )
}

export default TermsConditions
